import React from "react";
import { COLORS } from "../../../constants/colors";

const GradientBanner = () => {
  return (
    <div className="relative w-full h-48 rounded-lg overflow-hidden pr-4" style={{ backgroundColor: COLORS.purple }}>
      <div className="absolute inset-0 opacity-20">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-white rounded-full animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 2}s`,
            }}
          />
        ))}
      </div>

      {/* Content container */}
      <div className="relative h-full flex flex-col justify-center px-8 space-y-4">
        <h1 className="text-4xl font-bold text-white">
          Master AI Skills Today
        </h1>
        <div className="flex justify-between items-center w-full">
          <p className="text-white/90 max-w-xl">
            Discover expertly curated courses to enhance your AI skills, bridge
            knowledge gaps, and stay ahead in the evolving job market.
          </p>
          <div className="pt-2">
            <button className="text-white px-6 py-2 rounded-md transition-colors duration-200" style={{ backgroundColor: COLORS.purpleHover }}>
              Resume Courses
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GradientBanner;
